import type { FC } from "react";
import type { Address } from "viem";

import { CreditAccountHistory } from "../CreditAccountHistory";
import type { CreditAccountOperation, TokensList } from "../model";
import type { ProtocolsList } from "../protocols";

export interface CreditAccountOperationsProps {
  ops: CreditAccountOperation[];
  underlyingToken: Address;
  tokens: TokensList;
  protocols: ProtocolsList;
  chainId: number;
}

export const CreditAccountOperations: FC<CreditAccountOperationsProps> = ({
  ops,
  underlyingToken,
  tokens,
  protocols,
  chainId,
}) => {
  if (ops.length === 0) {
    return (
      <div className="text-sm text-gray-400">
        No credit-account operations were extracted from this transaction.
      </div>
    );
  }
  return (
    <CreditAccountHistory
      dataList={ops}
      underlyingToken={underlyingToken}
      tokens={tokens}
      protocols={protocols}
      chainId={chainId}
    />
  );
};
